<template>
  <div class="index-page">
    <div class="page-header">
      <div class="header-1280">
        <img class="header-logo" src="../../public/static/indexUse/logo3.svg" />
        <div class="header-right">
          <div class="change-lang" @click="changeLang">
            {{ nowLang }}
          </div>
          <div class="header-menu">
            <div v-for="menu in menuList"
                 :key="menu._id"
                 class="menu-item"
                 :class="{'active-menu': activeMenu._id === menu._id}"
                 @click="changeMenu(menu)">
              {{ $dt(menu, 'name') }}
            </div>
            <template v-for="menu in menuListServer">
              <a-dropdown v-if="menu.type === 'menu'" placement="bottomRight">
                <div class="menu-item" :class="{'active-menu': activeMenu._id === menu._id}">
                  {{ $dt(menu, 'name') }}
                </div>
                <template #overlay>
                  <a-menu>
                    <a-menu-item v-for="page in menu.children" :key="page._id">
                      <div class="menu-item-row" :class="{'active-sub-menu': `/${page._id}` === nowPath}" @click="goPage(menu,page)">{{ $dt(page, 'name') }}</div>
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
              <div v-if="menu.type === 'page'"
                   class="menu-item"
                   :class="{'active-menu': activeMenu._id === menu._id}"
                   @click="changeMenu(menu)">
                {{ $dt(menu, 'name') }}
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="page-body">
      <router-view />
    </div>
    <div class="footer-box">
      <div class="footer-container">
        <img class="footer-logo" src="../../public/static/indexUse/logo2.png" />
        <div class="footer-left">
          <div class="school-name">{{ $t('上海松江区爱菊学校') }}</div>
          <div class="school-info">{{ $t('地址') }}</div>
          <div class="school-info">{{ $t('小初') }}</div>
          <div class="school-info">{{ $t('高中') }}</div>
        </div>
        <div class="footer-right" :style="$i18n.locale === 'en'?{gap:'24px'}:{}">
          <div v-for="(column, index) in footerData" :key="index" class="footer-column">
            <div class="column-title">{{ $dt(column, 'name') }}</div>
            <div v-for="(item, subIndex) in column.sub" :key="subIndex" class="column-item">
              {{ $dt(item, 'name') }}
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="footer-divider"></div>
        <div class="record-info-row">
          <a target="_blank" class="record-info" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011702891376">
            <img src="../../public/static/beian.png" style="margin-right: 4px" />
            沪公网安备 31011702891376号
          </a>
          <a target="_blank" class="record-info" style="margin-left: 32px" href="http://beian.miit.gov.cn">沪ICP备12043526号-2</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "index",
  data() {
    return {
      menuList: [
        { _id: 1, name: '首页', nameEn: 'Home', link: '/home' },
      ],
      activeMenu: {},
      footerData: [
        {
          name: '关于我们',
          nameEn: 'About Us',
          sub: [
            { name: '爱菊简介', nameEn: 'Introduction to Aiju' },
            { name: '教育体系', nameEn: 'Education System' },
            { name: '招生信息', nameEn: 'Admission Information' }
          ]
        },
        {
          name: '学部介绍',
          nameEn: 'Department Introduction',
          sub: [
            { name: '小学部创新融合班', nameEn: 'Primary School Innovative Integration Class' },
            { name: '初中部科创融合班', nameEn: 'Junior High School Science & Innovation Integration Class' },
            { name: '小学初中双语融合班', nameEn: 'Primary & Junior High School Bilingual Integration Class' },
            { name: '高中部', nameEn: 'Senior High School Department' }
          ]
        },
        // {
        //   name: '学部介绍',
        //   nameEn: 'Department Introduction',
        //   sub: [
        //     { name: '日本EJU高中融合课程', nameEn: 'Japan EJU Senior High Integration Course' },
        //     { name: '香港DSE高中融合课程', nameEn: 'Hong Kong DSE Senior High Integration Course' },
        //     { name: '新加坡UIA高中融合课程', nameEn: 'Singapore UIA Senior High Integration Course' },
        //     { name: '英澳WACE高中融合课程', nameEn: 'UK & Australia WACE Senior High Integration Course' }
        //   ]
        // },
        {
          name: '课程介绍',
          nameEn: 'Course Introduction',
          sub: [
            { name: '艺术课程', nameEn: 'Art Courses' },
            { name: '体育课程', nameEn: 'PE Courses' },
            { name: '科学课程', nameEn: 'Science Courses' }
          ]
        },
        {
          name: '服务品质',
          nameEn: 'Service Quality',
          sub: [
            { name: '校园', nameEn: 'Campus' },
            { name: '饮食', nameEn: 'Catering' },
            { name: '校车', nameEn: 'School Bus' },
            { name: '学生服务', nameEn: 'Student Services' }
          ]
        }
      ],
    };
  },
  computed: {
    nowLang() {
      return this.$i18n.locale === 'zh' ? 'English' : '简体中文';
    },
    nowPath() {
      return this.$route.path;
    },
    menuListServer() {
      return this.$store.state.app.menuList;
    },
  },
  methods: {
    changeLang() {
      this.$i18n.locale = this.$i18n.locale === 'zh' ? 'en' : 'zh';
    },
    changeMenu(menu) {
      this.activeMenu = menu;
      if(menu.type === 'page' || menu.link){
        this.$router.push(menu.link || `/${menu._id}`);
      }
    },
    goPage(menu, page) {
      this.activeMenu = menu;
      const url = page.link || `/${page._id}`;
      this.$router.push(url);
    },
  },
  mounted() {
    this.activeMenu = this.menuList[0];
  }
};
</script>

<style lang="scss">
@use '../assets/scss/constant' as constant;

.menu-item-row {
  text-align: center;
  padding: 4px 12px;

  &.active-sub-menu {
    color: #003C82;
    font-weight: bold;
  }
}

.index-page {
  width: 100%;
  min-height: 100vh;
  background: #fff;

  .page-header {
    width: 100%;
    height: 80px;
    box-sizing: border-box;
    background: #ffffff;
    position: sticky;
    top: 0;
    z-index: 999;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.06);

    .header-1280 {
      width: 1280px;
      margin: auto;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .header-logo {
        height: 52px;
        width: auto;
        object-fit: contain;
      }
    }

    .header-right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-end;

      .header-menu {
        display: flex;
        align-items: center;
        gap: 36px;

        .menu-item {
          font-size: 16px;
          color: #003C82;
          cursor: pointer;
          transition: color 0.3s ease;
          white-space: nowrap;
          line-height: 40px;
          font-weight: bold;

          &:hover {
            color: #D93379;
          }

          &.active-menu {
            color: #D93379;
            font-weight: 500;
          }
        }

      }

      .change-lang {
        font-size: 14px;
        color: #003C82;
        cursor: pointer;
        white-space: nowrap;
        line-height: 40px;
        font-weight: bold;
      }
    }
  }

  .page-body {
    width: 100%;
  }

  .footer-box {
    width: 100%;
    background: #002250;
    padding: 60px 0 30px;
    box-sizing: border-box;

    .footer-container {
      width: 1280px;
      margin: 0 auto;
      display: flex;

      .footer-logo {
        height: 96px;
        width: 96px;
        margin-right: 24px;
      }

      .footer-left {
        flex: 1;

        .school-name {
          font-weight: bold;
          color: #fff;
          line-height: 20px;
          margin-bottom: 16px;
        }

        .school-info {
          color: #BCBCBC;
          line-height: 20px;
          margin-bottom: 16px;
        }
      }

      .footer-right {
        flex: 1;
        display: flex;
        gap: 68px;

        .footer-column {

          .column-title {
            font-weight: bold;
            color: #fff;
            line-height: 20px;
            margin-bottom: 16px;
            white-space: nowrap;
          }

          .column-item {
            color: #BCBCBC;
            line-height: 20px;
            margin-bottom: 16px;
            white-space: nowrap;
            cursor: pointer;

            &:hover {
              color: #fff;
            }
          }
        }
      }
    }

    .footer-bottom {
      width: 1280px;
      margin: 40px auto 0;

      .footer-divider {
        width: 100%;
        height: 1px;
        background: rgba(255, 255, 255, 0.2);
        margin-bottom: 24px;
      }

      .record-info-row {
        display: flex;
        align-items: center;
        justify-content: center;

        .record-info {
          display: flex;
          align-items: center;
          color: #fff;
          font-size: 14px;
          opacity: 0.7;
        }
      }
    }
  }
}
</style>
